import { render, staticRenderFns } from "./tm-location-hours-modal.vue?vue&type=template&id=535f653e&scoped=true&"
import script from "./tm-location-hours-modal.vue?vue&type=script&lang=ts&"
export * from "./tm-location-hours-modal.vue?vue&type=script&lang=ts&"
import style0 from "./tm-location-hours-modal.vue?vue&type=style&index=0&id=535f653e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f653e",
  null
  
)

export default component.exports